import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from '../../util/withRouter';
import Avatar from 'react-avatar';
import Button from 'react-bootstrap/Button';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import * as BECaller from '../../util/apiCaller';
import { hasManageBilling, hasManageUsers } from '../../util/roles';
import { revokeRequest } from '../../modules/Users/UsersActions';
import { setSuccessMessage } from '../../modules/App/ErrorsActions';
import { logout, requestAccount } from '../../modules/Auth/AuthActions';
import ShieldCheck from '../../assets/images/shield-check.svg';
import IntegrationsDropdown from '../../modules/Integrations/components/IntegrationsDropdown';
import ImageSize from '../ImageSize/ImageSize';

// Import Style
import './User.scss';
import logoutIcon from '../../assets/img/logout.svg';
import swaggerIcon from '../../assets/img/swagger.svg';
import mcpIcon from '../../assets/img/mcp.svg';
import integrationsIcon from '../../assets/images/integrations/integrations.svg';
import openInNewIcon from '../../assets/img/open-in-new-blue.svg';

class User extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    this.state = {
      popupVisible: false
    };
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
  }

  handleClick() {
    if (!this.state.popupVisible) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState(prevState => ({
      popupVisible: !prevState.popupVisible
    }));
  }

  handleOutsideClick(e) {
    // ignore clicks on the component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }

    this.handleClick();
  }

  onRequest = acc => {
    this.props.requestAccount(acc.accountId);
    this.setState({
      popupVisible: false
    });
  };

  revokeRequest = () => {
    this.props.revokeRequest();
  };

  handleChangeAccount = accId => {
    BECaller.api(`account/select/${accId}`).then(() => {
      global.window && window.location && window.location.replace('/');
    });
  };

  handleCreateAccount = () => {
    BECaller.api(`account/create`).then(() => {
      global.window && window.location && window.location.replace('/');
    });
  };

  renderCreateAccountButton = (enabled = true) => {
    const { user } = this.props;
    if (enabled && !user.hasOwnAccount) {
      return (
        <a
          href="javascript:void(0)"
          onClick={() => this.handleCreateAccount()}
          className='btn btn-sm btn-primary'
        >
          Create account
        </a>
      )
    }
  }

  logout = () => {
    let url;

    if (this.props.outside) {
      const p = this.props.plugin;
      const host = p.host || this.props.user.host;
      url = `login?app=${p.app}&boardId=${p.boardId}&host=${host}`;
    }

    this.props.logout(this.props.navigate, url);
  };

  handleCopied = () => {
    this.props.setSuccessMessage('Your API access token has been copied to your clipboard');
  };

  renderGetTokenButton = () => (
    <CopyToClipboard
      text={this.props.user.displayToken}
      onCopy={this.handleCopied}
    >
      <Button variant='link'>
        <img src={ShieldCheck} alt="Get Access Token"/> Get Access Token
      </Button>
    </CopyToClipboard>
  );

  renderMcpRefLink = () => (
    <Link to="/mcp-docs" className="btn btn-link">
      <img src={mcpIcon} alt="MCP & API Documentation" />
      MCP & API Documentation
    </Link>
  );

  renderProfileButtons = () => {
    const { user } = this.props;

    const manageBilling = hasManageBilling(user);
    const manageUsers = hasManageUsers(user);
    const bothEnabled = manageBilling && manageUsers;
    const isPartner = user.isPartner;
    const isCustomTrial = user.isCustomPlan && user.status === 'trial';

    if (isPartner) {
      return (
        <div className='profile-buttons'>
          {manageUsers && (
            <Link to="/users" className='btn btn-sm btn-secondary'>Manage Users</Link>
          )}
        </div>
      )
    } else {
      return (
        <div className='profile-buttons'>
          {manageUsers && (
            <Link to="/users" className='btn btn-sm btn-secondary' style={{gridRow: bothEnabled ? 2 : 1}}>Manage Users</Link>
          )}
          {manageBilling && !isCustomTrial && (
            <Link to="/billing" reloadDocument className='btn btn-sm btn-secondary' style={{gridRow: bothEnabled ? 2 : 1}}>Manage Billing</Link>
          )}
        </div>
      )
    }
  }

  render() {
    const { user, plugin, outside } = this.props;
    const isOutside = outside && !!plugin;
    const hasIntegrationsSelection = !isOutside && user && user.hasTenant;
    const relatedAccount = user.relatedAccounts && user.relatedAccounts[0];

    return (
      <div
        className='user'
        ref={node => {
          this.node = node;
        }}
      >
        <div className='user_img' onClick={this.handleClick}>
          {user && user.profile && user.profile.profileImg ? (
            <ImageSize src={user.profile.profileImg} alt="" />
          ) : (
            <Avatar name={user && user.profile ? user.profile.name : ''} size={28} round="8px" maxInitials={2} />
          )}
        </div>

        <div className='dropdown_user' style={{ display: this.state.popupVisible ? 'flex' : 'none' }}>
          {!!user.managedBy && (
            <div className='notification'>
              This account is managed by <strong>{user.managedBy}</strong>
            </div>
          )}
          <div className='profile_content'>
            <div className='profile-info'>
              <div className={`profile_text ${!!user.host && 'three-rows'}`}>
                <h2>{user && user.profile ? user.profile.name : ''}</h2>
                <p>{user.email}</p>
                {!!user.host && <p>{user.host}</p>}
                {this.renderGetTokenButton()}
                {this.renderMcpRefLink()}
                {hasIntegrationsSelection && (
                  <IntegrationsDropdown title="Manage Connections">
                    <Button variant='link'>
                      <img src={integrationsIcon} alt="Manage Connections"/> Manage Connections
                    </Button>
                  </IntegrationsDropdown>
                )}
              </div>
              <div className='avatar_change'>
                {user && user.profile && user.profile.profileImg ? (
                  <ImageSize src={user.profile.profileImg} alt="" />
                ) : (
                  <Avatar name={user && user.profile ? user.profile.name : ''} size={54} round="4px" maxInitials={2} />
                )}
              </div>
            </div>
            {relatedAccount && !relatedAccount.invited && (
              <div className='account-info'>
                There is an existing corporate account under your domain,{' '}
                <Link onClick={() => this.onRequest(relatedAccount)}>request access here →</Link>
              </div>
            )}
            {!!user.requestedAccount && (
              <div className='account-info'>
                We’ve notified your account managers.
                <br />
                <Link onClick={() => this.revokeRequest()}>Revoke request here →</Link>
              </div>
            )}

            {this.renderProfileButtons()}
          </div>

          {user.accounts &&
            user.accounts.map((u, i) => {
              return (
                <div key={i} className='profile-info' onClick={() => this.handleChangeAccount(u.accountId)}>
                  <div className='profile_text'>
                    <h2>{u.name}</h2>
                    <p>{u.email}</p>
                  </div>
                  <div className='avatar_change'>
                    {user && user.profile && user.profile.profileImg ? (
                      <img src={user.profile.profileImg} alt="" />
                    ) : (
                      <Avatar name={user && user.profile ? user.profile.name : ''} size={54} round="4px" maxInitials={2} />
                    )}
                  </div>
                  <a
                    href="javascript:void(0)"
                    onClick={() => this.handleChangeAccount(u.accountId)}
                    className='link'
                  ></a>

                </div>
              );
            })}
          {(!this.props.outside || !user.hasOwnAccount) && (
            <div className='profile_footer'>
              {!this.props.outside && (
                <Button onClick={this.logout} variant="primary-link" size="md">
                  Sign out <img src={logoutIcon} alt="" />
                </Button>
              )}
              {this.renderCreateAccountButton(false)}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSuccessMessage: msg => dispatch(setSuccessMessage(msg)),
    logout: (navigate, url) => dispatch(logout(navigate, url)),
    requestAccount: acc => dispatch(requestAccount(acc)),
    revokeRequest: () => dispatch(revokeRequest())
  };
};

const mapStateToProps = state => {
  return {
    plugin: state.app.plugin,
    outside: state.app.outside,
    user: state.auth.user
  };
};

const connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(User));
export { connected as User, User as TestUser };
